import { UserConsumer } from '../../core/providers/UserProvider';
import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import StandardAppBar from '../StandardAppBar';
import AccountApplications from './AccountApplications';
import AccountManager from './AccountManager';

class AccountApplication extends Component {

  render() {

    return (
      <UserConsumer>
        {({ user }) => {
          return <Switch>
            <Route exact path="/account" render={
              (props) => <AccountApplications {...props} user={user} appBar={<StandardAppBar title="Account" />} />} />
            <Route path={"/account/*"} render={
              (props) => <AccountManager {...props} user={user} {...this.props} />} />
          </Switch>;
        }}
      </UserConsumer>
    );
  }
}

export default AccountApplication;